import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, forwardRef, Renderer2, ElementRef} from '@angular/core';
import { Calendar, CalendarOptions } from '@fullcalendar/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import moment from 'moment';
import { Constants } from '../lib/constants';
import { GlobalConstants } from '../lib/global-constants';
import { DataService } from '../../core/services/data.service';
import { SnackbarService } from '../lib/services/snackbar.service';
import { ViewMeetingComponent } from '../lib/popup/view-meeting/view-meeting.component';
import { MeetingManagerService } from '../lib/services/meeting-manager.service';
import { MeetingMapping } from '../lib/mapping/meeting-mapping';
import { MeetingTypeList } from '../lib/models/meeting-type-model.model';
import { SharedCommonService } from '../../shared/services/shared-common.service';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DatePickerRange, ICalendarComponent, ICheckboxComponent, IDatePickerRange } from '@tylertech/forge';
import { Subscription } from 'rxjs';
import { DialogService } from '@tylertech/forge-angular';
import { NgModel } from '@angular/forms';
import {cloneDeep} from 'lodash';
import { SchedularDetailsModel } from '../lib/models/meeting-manager.model';
import { DatePipe } from '@angular/common';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { SubscribeDialogComponent } from '../lib/subscribe-dialog/subscribe-dialog.component';
@Component({
    selector: 'appc-meeting-manager',
    templateUrl: './meeting-manager.component.html',
    styleUrls: ['./meeting-manager.component.scss'],
    standalone: false,
})
export class MeetingManagerComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild(FullCalendarComponent) eventCalendar: FullCalendarComponent; // Reference to Event Scheduler Calendar
    monthCalendar: ICalendarComponent | null; // Reference to sidebar Month Calendar
    public eventCalendarConfig: CalendarOptions; // Configuration options for Event Scheduler Calendar
    public selectedDate: Date = new Date(); // Current Selected Date for Calendar
    meetingIndex: Number = -1;
    meetings: any; // Meeting Events to bind to Scheduler
    selectedCalendarView: string; // Currently selected view
    selectedSchedulerView: string;
    schedularDetails = new SchedularDetailsModel();
    dateRangeValue: IDatePickerRange;
    invalidDateRange = false;
    @ViewChild('startDate') startDateElement: ElementRef;
    @ViewChild('endDate') endDateElement: ElementRef;
    isEventSingleClick: Boolean = true; // Flag to check whether event is clicked once or double clicked
    schedulerDisplayMonth = ''; // display month title on scheduler
    listSchedulerEvents: any;
    allMeetingTypes: Array<MeetingTypeList> = [];
    selectedAll: boolean;
    selectedMeetingTypes: Array<number> = [];
    private noRepeat: string;
    private subscriptions: Subscription = new Subscription();
    contextmenu = true;
    contextMenuitems: any[] = [];
    public displaylist: any[];
    public isContentHeight = false;
    meetingPopUpdata: any;
    public calendarVisibility = true;
    drawerType: string;
    private moreLinkAriaObserver: MutationObserver | null = null;
    private calendarScrollObserver: MutationObserver | null = null;
    private calendarEventObserver: MutationObserver | null = null;

    constructor(
        public constants: Constants, // Services for Meeting Manager
        public globalConstants: GlobalConstants,
        public dataService: DataService,
        public snackbarService: SnackbarService, // Service used to display Notifications
        public meetingManagerService: MeetingManagerService,
        private meetingMapping: MeetingMapping,
        public sharedCommonService: SharedCommonService,
        private route: ActivatedRoute,
        private dialogService: DialogService,
        private router:Router,
        private renderer: Renderer2,
        private elementRef: ElementRef,
        private datePipe: DatePipe,
        private breakpointObserver: BreakpointObserver,
    ) {
        this.selectedMeetingTypes = [-1];
        this.setSchedularList();
    }
    /**
     * Setting the data for the reuaable component for schedular list
     *
     * @memberof MeetingManagerComponent
     */
    setSchedularList(keepDateRangeValue = false) {
        let meetingTypeIds = this.selectedMeetingTypes[0] === -1 ? [] : this.selectedMeetingTypes;
        if (this.selectedMeetingTypes.length === 0) {
            meetingTypeIds = [-1];
        }
        this.schedularDetails = {
            selectedDate: this.selectedDate,
            meetingTypeIds: meetingTypeIds,
            isMobileMode: this.sharedCommonService.isMobileResolution,
            startDate: keepDateRangeValue ? this.schedularDetails.startDate : '',
            endDate: keepDateRangeValue ? this.schedularDetails.endDate : ''
        };
    }
    ngAfterViewInit() {
        const leftPane: HTMLElement = document.getElementById('leftPanel') as HTMLElement;
        const divCal: HTMLElement = document.getElementById('divCal') as HTMLElement;
        const divMeetingType: HTMLElement = document.getElementById('meeting-type') as HTMLElement;
        const leftHeight: number = leftPane ? leftPane.offsetHeight : 0;
        const divCalendar: number = divCal ? divCal.offsetHeight : 0;
        const divMeeting: number = divMeetingType ? divMeetingType.offsetHeight : 0;
        if (leftHeight <= divCalendar + divMeeting) {
            this.isContentHeight = true;
        }
        this.setDateInCalendarView();
        this.enhanceAccessibility();

        if (this.globalConstants.getSessionStorage('calendarMeetingTypes')) {
            this.selectedMeetingTypes = this.globalConstants.getSessionStorage('calendarMeetingTypes');
        }
    }

    enhanceAccessibility() {
        const divElements = this.querySelectorAll('div');
        const tdElements = this.querySelectorAll('td');
        const anchorElements = this.querySelectorAll('a');

        this.removeAttribute(divElements,'aria-labelledby');
        this.removeAttribute(tdElements,'aria-labelledby');
        this.setAttribute(anchorElements,'role','button');
        const elementsWithAriaHidden = this.elementRef.nativeElement.querySelectorAll('[aria-hidden]');
        elementsWithAriaHidden.forEach((element: Element) => {
            this.renderer.removeAttribute(element, 'aria-hidden');
        });

        this.removeUnsupportedAriaFromMoreLinks();
        this.observeMoreLinkAria();
        this.setADACalendarControls();
        this.observeCalendarScrollContainers();
        this.applyCalendarEventAccessibility();
        this.observeCalendarEventElements();
      }
      removeUnsupportedAriaFromMoreLinks(): void {
        const moreLinks = this.querySelectorAll('.fc-daygrid-more-link');
        moreLinks.forEach((link: Element) => {
            this.renderer.removeAttribute(link, 'aria-expanded');
            this.renderer.removeAttribute(link, 'aria-controls');
            this.renderer.setAttribute(link, 'role', 'button');
            const ariaLabel = link.getAttribute('aria-label') || link.getAttribute('title') || link.textContent?.trim();
            if (ariaLabel) {
                this.renderer.setAttribute(link, 'aria-label', ariaLabel);
            }
        });
      }

      observeMoreLinkAria(): void {
        if (this.moreLinkAriaObserver) {
            return;
        }
        const targetNode = document.querySelector('.fc-daygrid') || document.body;
        if (!targetNode) {
            return;
        }
        this.moreLinkAriaObserver = new MutationObserver((mutations: MutationRecord[]) => {
            let shouldClean = false;
            mutations.forEach((mutation: MutationRecord) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node: Node) => {
                        if (node instanceof HTMLElement &&
                            (node.classList.contains('fc-daygrid-more-link') || node.querySelector('.fc-daygrid-more-link'))) {
                            shouldClean = true;
                        }
                    });
                } else if (mutation.type === 'attributes' &&
                    (mutation.target as Element).classList?.contains('fc-daygrid-more-link')) {
                    shouldClean = true;
                }
            });
            if (shouldClean) {
                this.removeUnsupportedAriaFromMoreLinks();
            }
        });
        this.moreLinkAriaObserver.observe(targetNode, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['aria-expanded', 'aria-controls']
        });
      }

      removeAttribute(elements:NodeListOf<Element>,attributeName:string){
        if (elements?.length) {
            elements.forEach((element)=> this.renderer.removeAttribute(element, attributeName));
        }
      }

      setAttribute(elements:NodeListOf<Element>,attributeName:string,attributeValue:string){
        if (elements?.length) {
            elements.forEach((element)=> this.renderer.setAttribute(element, attributeName, attributeValue));
        }
      }

      private querySelectorAll(selector: string): NodeListOf<Element> {
        return document.querySelectorAll(selector);
      }

      private applyCalendarScrollerAccessibility(): void {
        const calendarScrollContainers = this.querySelectorAll('.fc-scroller');
        calendarScrollContainers.forEach((container: Element) => {
            this.renderer.setAttribute(container, 'role', 'presentation');
        });
      }

      private observeCalendarScrollContainers(): void {
        if (this.calendarScrollObserver) {
            return;
        }
        const targetNode = this.elementRef.nativeElement.querySelector('.fc-view-harness') || document.body;
        if (!targetNode) {
            return;
        }
        this.calendarScrollObserver = new MutationObserver(() => {
            this.applyCalendarScrollerAccessibility();
        });
        this.calendarScrollObserver.observe(targetNode, {
            childList: true,
            subtree: true
        });
      }

      private applyCalendarEventAccessibility(): void {
          const eventElements = this.querySelectorAll('.fc-event');
          eventElements.forEach((element: Element) => {
              this.renderer.setAttribute(element, 'role', 'button');
              if (!element.getAttribute('aria-label')) {
                  const labelText = element.textContent?.trim() || 'Calendar event';
                  this.renderer.setAttribute(element, 'aria-label', labelText);
              }
          });
      }

      private observeCalendarEventElements(): void {
          if (this.calendarEventObserver) {
              return;
          }
          const targetNode = this.elementRef.nativeElement.querySelector('.fc-view-harness') || document.body;
          if (!targetNode) {
              return;
          }
          this.calendarEventObserver = new MutationObserver(() => {
              this.applyCalendarEventAccessibility();
          });
          this.calendarEventObserver.observe(targetNode, {
              childList: true,
              subtree: true
          });
      }

      setADACalendarControls(): void {
          const anchorElements = this.querySelectorAll('table');
          this.removeAttribute(anchorElements,'role');
          const tableBodyElements = this.querySelectorAll('tbody');
          this.removeAttribute(tableBodyElements,'role');
          const tableHeadElements = this.querySelectorAll('thead');
          this.removeAttribute(tableHeadElements,'role');

          const calendarElement = this.querySelectorAll('.custom-list-body')[0] as HTMLElement;
          if (calendarElement !== undefined) {
              this.renderer.setAttribute(calendarElement, 'id', 'main-calendar-scrollbar');
              this.renderer.setAttribute(calendarElement, 'tabindex', '0');
              this.renderer.setAttribute(calendarElement, 'role', 'scrollbar');
              this.renderer.setAttribute(calendarElement, 'aria-controls', 'main-calendar-scrollbar');
              this.renderer.setAttribute(calendarElement, 'aria-valuenow', '0');
          }
          this.applyCalendarScrollerAccessibility();
      }

    /**
     * Angular ngOnInit lifecycle method
     */
    ngOnInit() {
        this.route.params.subscribe((params: Params) => {
            if (params['meetingId']) {
                this.meetingPopUpdata = {data: {
                    id: Number,
                    recurringId: Number,
                    isDirect: Boolean
                }};
                this.meetingPopUpdata.data.id = params['meetingId'];
                this.meetingPopUpdata.data.recurringId = params['recurringId'];
                this.meetingPopUpdata.data.isDirect = true;
                this.openViewDetailsDialog(this.meetingPopUpdata);
            }
          });
        this.onInit();
    }

    /**
     *Get Selected MeetingType ID
     *
     * @memberof MeetingManagerComponent
     */
    getSelectedMeetingType() {
        this.selectedMeetingTypes = this.allMeetingTypes.filter(v => v.selected === true).map(v => v.id);
    }

    /**
     *When on of the checkbox not selected then unchecking all.
     *
     * @memberof MeetingManagerComponent
     */
    checkIfAllSelected(index: number, keepDateRangeValue = false) {
        this.meetingIndex = index;
        this.getSelectedMeetingType();
        this.selectedAll = this.allMeetingTypes.length === this.selectedMeetingTypes.length;
        this.setSchedularList(keepDateRangeValue);
        this.prepareScheduler(keepDateRangeValue);

        this.globalConstants.setSessionStorage('calendarMeetingTypes', this.selectedMeetingTypes);
    }
    /**
     *Selectall meetingtype
     *
     * @memberof MeetingManagerComponent
     */
    selectAllMeetingType(keepDateRangeValue = false) {
        this.selectedMeetingTypes = [];
        const length = this.allMeetingTypes.length;
        const tempMeetingType:MeetingTypeList[] = cloneDeep(this.allMeetingTypes);
        for (let i = 0; i < length; i++) {
            tempMeetingType[i].selected = this.selectedAll;
        }
        this.allMeetingTypes = tempMeetingType;
        this.getSelectedMeetingType();
        this.setSchedularList(keepDateRangeValue);
        this.prepareScheduler(keepDateRangeValue);
        
        this.globalConstants.setSessionStorage('calendarMeetingTypes', this.selectedMeetingTypes);
    }

    /**
     *Binding the meeting type
     *
     * @memberof MeetingManagerComponent
     */
    bindMeetingType(): void {
        this.allMeetingTypes = [];
        this.subscriptions.add(this.meetingManagerService.getMeetingTypeList().subscribe((res: any) => {
            this.allMeetingTypes = this.meetingMapping.getMeetingTypeList(res);
            if (this.globalConstants.getSessionStorage('calendarMeetingTypes')) {
                this.selectedMeetingTypes = this.globalConstants.getSessionStorage('calendarMeetingTypes');
                this.onSelectMeetingType(this.selectedMeetingTypes);
            } else {
                this.getSelectedMeetingType();
            }

            this.monthCalendar = document.querySelector('forge-calendar');
        }, (error: any) => {
            console.error('bindMeetingType', JSON.stringify(error));
        }));
    }
    /**
     *Initalize  function.
     *
     * @memberof MeetingManagerComponent
     */
    onInit(): void {
        this.meetingManagerService.removingSessionMeetingType();
        this.selectedAll = true;
        this.bindMeetingType();
        const dateFormat = this.globalConstants.format.date;
        const todayDate = moment(new Date(), dateFormat);
        const selectedDate = moment(this.meetingManagerService.getSelectedDate(), dateFormat);
        this.selectedCalendarView = this.meetingManagerService.getSchedulerView();
        if (todayDate !== selectedDate) {
            this.setDate(selectedDate.toDate());
        } else {
            this.setDate('today');
        }
        this.noRepeat = this.constants.meetingConfig.meetingType.noRepeat;
        this.prepareScheduler();

        this.subscriptions.add(this.breakpointObserver.observe([
            "(max-width: 1024px)"
        ]).subscribe((result: BreakpointState) => {
            const drawerShouldBeModal = result.matches;
            this.drawerType = drawerShouldBeModal ?
                this.constants.drawerTypes.modal :
                this.constants.drawerTypes.dismissable;

            // If drawer is a modal automatically open it and show the calendar filter drawer.
            if (this.calendarVisibility && this.schedularDetails.isMobileMode) {
                this.calendarVisibility = false;
            } else {
                this.calendarVisibility = !drawerShouldBeModal;
            }
            
            // Scroll to the top of the page on reload.
            const topOfPage = document.getElementById('top-of-page');
            topOfPage?.scroll(0, 0);

            this.schedularDetails.isMobileMode = drawerShouldBeModal;
            const criteriaDate = this.selectedDate;
            const startDate = moment(criteriaDate).startOf('month').format(dateFormat);
            const endDate = moment(criteriaDate).endOf('month').format(dateFormat);
            this.setDateRangeValues(startDate, endDate);
        }));
    }

setConfig() {
        forwardRef(() => Calendar);
        const contentHeight: number = window.innerHeight - 40;
        // Configures the Scheduler to bind the data.
        this.eventCalendarConfig = {
            editable: false,
            dropAccept: '.fc-content-skeleton',
            views: {
                dayGridMonth: {
                    dayMaxEventRows: 3 // adjust to 6 only for agendaWeek/agendaDay
                },
                timeGrid: {
                    dayMaxEventRows: 3 // adjust to 6 only for timeGridWeek/timeGridDay
                  }
            },
            headerToolbar: {
                left: '',
                center: '',
                right: ''
            },
            weekends: true,
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            events: this.meetings,
            initialView: this.selectedCalendarView ? this.selectedCalendarView : 'dayGridMonth',
            allDaySlot: false,
            allDayText: '',
            dayMaxEventRows: true,
            businessHours: {
                // days of week. an array of zero-based day of week integers (0=Sunday)
                daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
                startTime: this.constants.meetingConfig.startTime, // a start time (in 24 hour format)
                endTime: this.constants.meetingConfig.endTime, // an end time (in 24 hour format)
            },
            contentHeight: contentHeight,
            height: contentHeight,
            showNonCurrentDates: false,
            eventOverlap: true,
            scrollTime: '06:00:00',
            eventContent: this.eventRender.bind(this),
            eventClick: this.eventClick.bind(this),
            windowResize: this.windowResize.bind(this),
            eventDidMount: this.contectMenu.bind(this),
        };
    }

    /**
     * Prepares the Scheduler for its event bindings
     * params - criteriaDate Date to which scheduler should be bound
     * params - criteria week/day/month/list
     * @memberof MeetingManagerComponent
     */
    prepareScheduler(keepDateRangeValue = false): void {
        let startDate: any, endDate: any;
        const criteriaDate = this.selectedDate;
        const dateFormat = this.globalConstants.format.date;
        const url = this.globalConstants.baseUrl + this.constants.serviceUrl.meeting.getMeetingByDateRange;

        // If keepDateRangeValue is true and we have custom date ranges, use them for the API call
        if (keepDateRangeValue && this.schedularDetails.isMobileMode &&
            this.schedularDetails.startDate && this.schedularDetails.endDate) {
            startDate = this.schedularDetails.startDate;
            endDate = this.schedularDetails.endDate;
        } else {
            switch (this.selectedCalendarView) {
                case 'timeGridWeek': {
                    this.selectedSchedulerView = 'timeGridWeek';
                    startDate = moment(criteriaDate).startOf('week').format(dateFormat);
                    endDate = moment(criteriaDate).endOf('week').format(dateFormat);
                    break;
                }
                case 'dayGridMonth':
                case 'list':
                    {
                        this.selectedSchedulerView = 'dayGridMonth';
                        startDate = moment(criteriaDate).startOf('month').format(dateFormat);
                        endDate = moment(criteriaDate).endOf('month').format(dateFormat);
                        break;
                    }
                case 'timeGridDay': {
                    this.selectedSchedulerView = 'timeGridDay';
                    startDate = moment(criteriaDate).format(dateFormat);
                    endDate = moment(criteriaDate).format(dateFormat);
                    break;
                }
                default: {
                    this.selectedSchedulerView = 'timeGridWeek';
                    startDate = moment(criteriaDate).startOf('week').format(dateFormat);
                    endDate = moment(criteriaDate).endOf('week').format(dateFormat);
                    break;
                }
            }
            if (!keepDateRangeValue) {
                this.setDateRangeValues(startDate, endDate);
            }
        }
        this.setConfig();
        const params = { startDate: startDate, endDate: endDate,
            meetingTypeIds: this.selectedMeetingTypes.length === 0 ? [-1] : this.selectedMeetingTypes };
        if (this.selectedCalendarView === 'timeGridDay' || this.selectedCalendarView === 'dayGridMonth'
            || this.selectedCalendarView === 'timeGridWeek') {

            // Calls MeetingsForWeek Service to fetch all meetings for given week
            this.subscriptions.add(this.dataService.post(url, params).subscribe((res: any) => {
                this.prepareEvents(res);
            }, (error: any) => {
                this.prepareEvents(null);
                console.log('prepareEvents');
                console.log(JSON.stringify(error));
                this.snackbarService.showMessage(this.constants.messages.error.internalServerError);
            }));
        }
    }

    /**
     * Prepares the Events for Scheduler
     * params - res response from which scheduler should get prepared
     * @memberof MeetingManagerComponent
     */
    prepareEvents(response: any): void {
        this.meetings = [];
        if (response !== null) {
            this.meetings = this.meetingMapping.setMeetingScheduler(response).slice(0);
        }
        this.setConfig();
            if (this.eventCalendar && document.getElementById('FC') !== undefined) {
                const eventCalendar = this.eventCalendar;
                const calendarApi = this.eventCalendar.getApi();
                calendarApi.changeView(this.selectedCalendarView);
                calendarApi.gotoDate(this.selectedDate);
                this.eventCalendarConfig.editable = false;
                this.eventCalendarConfig.droppable = false;
                this.eventCalendarConfig.eventDurationEditable = false;
                this.eventCalendarConfig.dragScroll = false;
                calendarApi.updateSize();
                calendarApi.refetchEvents();
                this.eventCalendarConfig.initialDate = this.selectedDate;
                this.setDateInCalendarView();
                this.viewRender(eventCalendar);
            }
        this.enhanceAccessibility();
    }

    contectMenu(domEvent: any) {
        domEvent.el.style.backgroundColor = domEvent.backgroundColor;
        domEvent.el.style.borderColor = domEvent.borderColor;
        domEvent.el.style.color = domEvent.textColor;
        domEvent.el.style.overflow = 'hidden';
        domEvent.el.addEventListener('dblclick', () => {
            this.schedulerEventDoubleClicked(domEvent.event);
        });
    }

    /**
     * Called when Next > button is clicked from Scheduler Calendar header
     *
     * @memberof MeetingManagerComponent
     */
    eventCalendarNextClicked() {
        if (this.eventCalendar) {
            const calendarApi = this.eventCalendar.getApi();
            calendarApi.next();
        }

        switch (this.selectedCalendarView) {
            case 'timeGridDay': {
                this.setDate(moment(this.selectedDate).add(1, 'days').toDate());
                break;
            }
            case 'dayGridMonth': {
                this.setDate(moment(this.selectedDate).add(1, 'months').toDate());
                break;
            }
            case 'timeGridWeek': {
                this.setDate(moment(this.selectedDate).add(1, 'weeks').toDate());
                break;
            }
            case 'list': {
                this.setDate(moment(this.selectedDate).add(1, 'months').toDate());
                break;
            }
            default: {
                this.setDate(moment(this.selectedDate).add(1, 'weeks').toDate());
                break;
            }
        }
    }

    /**
    * Called when Previous < button is clicked from Scheduler Calendar header
    *
    * @memberof MeetingManagerComponent
    */
    eventCalendarPreviousClicked() {
        if (this.eventCalendar) {
            const calendarApi = this.eventCalendar.getApi();
            calendarApi.prev();
        }

        switch (this.selectedCalendarView) {
            case 'timeGridDay': {
                this.setDate(moment(this.selectedDate).subtract(1, 'days').toDate());
                break;
            }
            case 'dayGridMonth': {
                this.setDate(moment(this.selectedDate).subtract(1, 'months').toDate());
                break;
            }
            case 'timeGridWeek': {
                this.setDate(moment(this.selectedDate).subtract(1, 'weeks').toDate());
                break;
            }
            case 'list': {
                this.setDate(moment(this.selectedDate).subtract(1, 'months').toDate());
                break;
            }
            default: {
                this.setDate(moment(this.selectedDate).subtract(1, 'weeks').toDate());
                break;
            }
        }
    }

    /**
    * Displays Currently selected month on Scheduler Header
    *
    * @memberof MeetingManagerComponent
    */
    getCurrentDisplayedMonth() {
        const date = new Date(this.selectedDate);
        const monthText = moment(date).format('MMMM YYYY');
        this.schedulerDisplayMonth = monthText;
    }

    windowResize(event: any) {
        if (this.eventCalendarConfig !== null && this.eventCalendarConfig !== undefined) {
            const calendarApi = this.eventCalendar.getApi();
            calendarApi.updateSize();
            const contentHeight: number = window.innerHeight - 85;
            calendarApi.setOption('height', contentHeight);
            calendarApi.setOption('contentHeight', contentHeight);
            calendarApi.refetchEvents();
        }
    }

    /**
     * Called when view is rendered on Scheduler
     * params - view Event Object for rendering
     * @memberof MeetingManagerComponent
     */
    viewRender(view: any) {
        const dateToFind = moment(this.selectedDate).format('YYYY-MM-DD');
        // tslint:disable-next-line:quotemark
        const data: any = document.querySelectorAll("[data-date='" + dateToFind + "']");
        data[0].style.backgroundColor = 'rgba(74,144,226,0.2)';
        if(data.length > 1) {
            data[1].style.backgroundColor = 'rgba(74,144,226,0.2)';
            if(data[2]) {
                data[2].style.backgroundColor = 'rgba(74,144,226,0.2)';
            }
        }
        if (this.selectedCalendarView === 'timeGridWeek' || this.selectedCalendarView === 'timeGridDay') {
            let incDate = moment(this.selectedDate).startOf('week');
            for (let i = 0; i < 7; i++) {
                const dateLoop = moment(incDate).format('YYYY-MM-DD');
                // tslint:disable-next-line:quotemark
                const dataLoop = document.querySelectorAll("[data-date='" + dateLoop + "']");
                if (dataLoop.length > 0) {
                    const displayDateHTML: any = dataLoop[0].getElementsByTagName('a');
                    displayDateHTML[0].style.display = 'none';
                    const span = dataLoop[0].getElementsByTagName('span');
                    if(span) {
                        for (let i = 0; i < span.length; i++) {
                            span[i].remove();
                        }
                    }
                    const newSpan = document.createElement('span');
                    newSpan.innerHTML = `<div style="color: #505050;text-align:left;">${incDate.format('ddd')}</div>
                    <div style="font-size: 40px; margin-top: 5px; color: #5A5A5A;text-align:left;">${incDate.format('D')}</div>`;
                    dataLoop[0].append(newSpan);
                }
                incDate = incDate.add(1, 'days');
            }
            if (this.selectedCalendarView === 'timeGridDay') {
                let startTime = this.constants.meetingConfig.startLoopTime;
                for (let i = 0; i < this.constants.meetingConfig.endLoopTime; i++) {
                    let str = '';
                    if (Math.abs(i % 2) === 1) {
                        str = startTime < 10 ? `0${startTime}:30:00` : `${startTime}:30:00`;
                        startTime++;
                    } else {
                        str = startTime < 10 ? `0${startTime}:00:00` : `${startTime}:00:00`;
                    }
                    // tslint:disable-next-line:quotemark
                    const dataLoop: any = document.querySelector("[data-time='" + str + "']");
                    if(dataLoop && dataLoop.childNodes[1]) {
                        dataLoop.childNodes[1].style.backgroundColor = '#ffff';
                    }
                }
            }
        }
    }

    /**
     * Called when events are rendered onon Scheduler
     * params - domEvent Event Object for rendering
     * @memberof MeetingManagerComponent
     */
    eventRender(domEvent: any) {
        if (this.meetingIndex !== undefined && this.meetingIndex !== null) {
            const target: any = document.getElementById('chkMeetingType' + this.meetingIndex.toString());
            if (target) {
                target.scrollIntoViewIfNeeded();
            }
        }
        let html = ``;
        if (this.selectedCalendarView === 'dayGridMonth') {
            const dateFormat = this.globalConstants.format.date;
            const timeFormat = this.globalConstants.format.time;
            const time = moment(moment(domEvent.event.extendedProps.data.startDateTime).format(dateFormat) +
             ' ' + domEvent.event._def.extendedProps.data.startTime).format(timeFormat)
            html = `
                <div class='meeting-box-container-month'>
                    <span class='meeting-time-text'>
                        ${time}
                    </span>
                    <span class='long-data-styling meeting-title-text'>
                        ${domEvent?.event?._def?.title}
                    </span>
                </div>
                <forge-tooltip>${domEvent?.event?._def?.title}</forge-tooltip>
            `;
        } else { // Week and Day
            if (domEvent.event._def.allDay) {
                html = `<div class='meeting-box-container'>
                <div class='meeting-title  long-data-styling'>
                    ${domEvent?.event?._def.title},${domEvent?.event?._def?.extendedProps?.data?.startTime}
                </div>
                <forge-tooltip>
                ${domEvent?.event?._def?.title}
                </forge-tooltip>
                <div class='location-container'>
                    <forge-icon name="calendar_today" aria-hidden="false" ></forge-icon>
                    <div class='location-text long-data-styling'>
                    ${domEvent?.event?._def?.extendedProps?.data?.location}
                    </div>
                    <forge-tooltip>
                    ${domEvent?.event?._def?.extendedProps?.data?.location}
                    </forge-tooltip>
                </div>                
            </div>`
            } else {
                html = `<div class='meeting-box-container'>
                    <div class='meeting-title  long-data-styling'>
                        ${domEvent?.event?._def?.title}
                    </div>
                    <forge-tooltip position='right'>
                    ${domEvent?.event?._def?.title}
                    </forge-tooltip>
                    <div class='location-container'>
                        <forge-icon name="calendar_today" aria-hidden="false" ></forge-icon>
                        <div class='location-text long-data-styling'>
                        ${domEvent?.event?._def?.extendedProps?.data?.location}
                        </div>
                        <forge-tooltip position='right'>
                        ${domEvent?.event?._def?.extendedProps?.data?.location}
                        </forge-tooltip>
                    </div>                
                </div>`
            }
        }
        this.enhanceAccessibility();
        return {html: html};
    }

    bindOnScroll() {
        const scrollElement: HTMLElement = document.getElementsByClassName('fc-time-grid-container')[0] as HTMLElement;
        const ctxElement: HTMLElement = document.getElementById('ctx') as HTMLElement;
        const ctxSubMenu: HTMLElement = document.getElementById('ctxSubMenu') as HTMLElement;
        if (scrollElement !== undefined) {
            scrollElement.onscroll = function () {
                ctxElement.style.visibility = 'hidden';
                ctxSubMenu.style.visibility = 'hidden';
            };
        }
    }

    /**
     * Called when Schedluer events are single clicked
     *
     * @param {*} e Dom Right Click Client Event
     * @param {*} event object of scheduler event
     * @memberof MeetingManagerComponent
     */
    schedulerEventRightClicked(e: any, event: any) {
        if (event.data.isAdjourned === true) {
            this.contextMenuitems = [
                {
                    id: 0, text: 'View Meeting', data: event
                }
            ];
        } else {
            if (event.data.recurringType === this.noRepeat) {
                this.contextMenuitems = [
                    {
                        id: 0, text: 'View meeting', data: event
                    }

                ];
            } else {

                this.contextMenuitems = [
                    {
                        id: 0, text: 'View meeting', data: event
                    }
                ];
            }
        }
    }


    /**
     * Called when scheduler event is double clicked
     *
     * @param {*} event object of scheduler event
     * @memberof MeetingManagerComponent
     */
    schedulerEventDoubleClicked(event: any) {
    }

    /**
     * Called when view change button is pressed from side panel
     * params - view week/day/list/month
     * @memberof MeetingManagerComponent
     */
    changeCalendarView(view: any): void {
        this.meetingManagerService.setSchedulerView(view);
        switch (view) {
            case 'timeGridDay': {
                this.meetingManagerService.setSelectedTime(null);
                this.selectedCalendarView = 'timeGridDay';
                if (this.eventCalendar) {
                    const calendarApi = this.eventCalendar.getApi();
                    calendarApi.changeView('timeGridDay');
                } else {
                    this.prepareScheduler();
                }
                break;
            }
            case 'dayGridMonth': {
                this.selectedCalendarView = 'dayGridMonth';
                if (this.eventCalendar) {
                    const calendarApi = this.eventCalendar.getApi();
                    calendarApi.changeView('dayGridMonth');
                } else {
                    this.prepareScheduler();
                }
                break;
            }
            case 'timeGridWeek': {
                this.selectedCalendarView = 'timeGridWeek';
                if (this.eventCalendar) {
                    const calendarApi = this.eventCalendar.getApi();
                    calendarApi.changeView('timeGridWeek');
                } else {
                    this.prepareScheduler();
                }
                break;
            }
            case 'list': {
                this.selectedCalendarView = 'list';
                this.setSchedularList();
                break;
            }
            default: {
                this.selectedCalendarView = 'timeGridWeek';
                if (this.eventCalendar) {
                    const calendarApi = this.eventCalendar.getApi();
                    calendarApi.changeView('timeGridWeek');
                } else {
                    this.prepareScheduler();
                }
                break;
            }
        }
        this.prepareScheduler();
    }
    /**
     * Called on Date Change from Month Calendar
     *
     * @memberof MeetingManagerComponent
     */
    monthCalendarDateChanged(date: CustomEvent): void {
        // to avoid multiple calls to setDate method
        if (date?.detail?.date && (moment(this.selectedDate).format('YYYY-MM-DD') !== moment(date?.detail?.date).format('YYYY-MM-DD'))) {
            this.setDate(date.detail.date);
        }
    }

    updateCalendarView() {
        const dateToFind = moment(this.selectedDate).format('YYYY-MM-DD');
        // get element reference of cell in full-calendar
        const data: any = document.querySelectorAll("[data-date='" + dateToFind + "']");
        if (data[0]) { data[0].style.backgroundColor = ''; }
        if(data.length > 1) {
            data[1].style.backgroundColor = '';
            if(data[2]) {
                data[2].style.backgroundColor = '';
            }
        }
    }

    /**
     * Sets Date in Event and Month Calendar
     *
     * @memberof MeetingManagerComponent
     */
    setDate(date: any): void {
        this.updateCalendarView();
        if (date === 'today') {
            this.selectedDate = new Date();
        } else {
            this.selectedDate = date;
        }
        if (this.selectedCalendarView === 'list') {
            this.setDateInCalendarView();
            this.setSchedularList();
        } else {
            this.prepareScheduler();
        }
        this.getCurrentDisplayedMonth();

    }

    /**
     * Opens AddMeeting Dialog to create a Meeting
     * @param meeting fetch meetingid and recurringid from this object
     * @memberof MeetingManagerComponent
     */
    openViewDetailsDialog(meeting: any): void {
        const meetingData = meeting.extendedProps ? meeting.extendedProps.data : meeting.data;
        this.meetingManagerService.setSelectedDate(this.selectedDate);
        this.dialogService.open(
            ViewMeetingComponent,
            {
              data: {
                meetingId: meetingData.id,
                recurringId: meetingData.recurringId,
                backgroundColor: meeting.uri ? meeting.ui.borderColor : "",
                isDirect: meetingData.isDirect,
              },
              options: this.constants.setDialogOptions(
                false,
                this.constants.forgeDialog.dialogClass
              )
            }
        );

    }

    openSubscribeDialog(): void {
        this.dialogService.open(
            SubscribeDialogComponent, 
            {
                data: {},
                options: this.constants.setDialogOptions(
                  false,
                  this.constants.forgeDialog.dialogSubscriptionClass
                )
              }
        );
    }

    /**** UTILITY METHODS ****/

    /**
     * Extracts Time in 'Hh:mm AP/PM' format
     *
     * @private
     * @param {*} date Passed date value
     * @returns formatted timeeventRender
     * @memberof AddMeetingComponent
     */
    formatDateToTime(date: any): string {
        const timeFormat = this.globalConstants.format.time;
        return moment(date).format(timeFormat);
    }

    eventClick(event: any) {
        this.openViewDetailsDialog(event.event._def);
        this.closeMoreLinkPopup();
    }

    closeMoreLinkPopup() {
        // to find and remove more link popup from UI
        const popupElements = document.getElementsByClassName('fc-more-popover');
        if (popupElements?.length) {
            popupElements[0].remove();
        }
    }

    setDateInCalendarView() {
        if (this.monthCalendar) {
            this.monthCalendar.selectDate(this.selectedDate);
            this.monthCalendar.month = this.selectedDate.getMonth();
            this.monthCalendar.year = this.selectedDate.getFullYear();
        }
    }
    navigateToSearchResult(search:NgModel){
        this.router.navigate(['search-result'],{queryParams:{search:search.value}});
    }

    ngOnDestroy() {
        this.moreLinkAriaObserver?.disconnect();
        this.moreLinkAriaObserver = null;
        this.calendarScrollObserver?.disconnect();
        this.calendarScrollObserver = null;
        this.calendarEventObserver?.disconnect()
        this.calendarEventObserver = null;
        this.subscriptions.unsubscribe();
    }

    getStyles(selected: boolean, colorHexCode: string, index: number) {
        const el: ICheckboxComponent | null =  document.querySelector(`[id^=chkMeetingType][id$='${index}']`);
        if (el) {
            el.style.setProperty('--forge-theme-tertiary', selected ? colorHexCode : 'white');
            el.style.setProperty('--forge-theme-text-medium', !selected ? colorHexCode : 'white');
        }
    }

    setDateRangeValues(startDate: string, endDate: string) {
        this.schedularDetails.startDate = this.schedularDetails.isMobileMode ? this.setDateFormat(startDate) : '';
        this.schedularDetails.endDate = this.schedularDetails.isMobileMode ? this.setDateFormat(endDate) : '';
        this.dateRangeValue = {
            from: this.schedularDetails.startDate,
            to: this.schedularDetails.endDate
        };
    }

    dateRangeChange(event: CustomEvent<DatePickerRange>) {
        if (event.detail.from && event.detail.to && event.detail.from <= event.detail.to) {
            this.dateRangeValue = {
                from: this.setDateFormat(event.detail.from || ""),
                to: this.setDateFormat(event.detail.to || ""),
            };
            const startDate = this.setDateFormat(
                event.detail.from
            );
            const endDate = this.setDateFormat(
                event.detail.to
            );
            // update schedularDetails to fetch meeting list based on selection
            this.schedularDetails = { ...this.schedularDetails, startDate, endDate };
            this.invalidDateRange = false;
            // blur date range selection inputs after user selection
            this.startDateElement?.nativeElement.blur();
            this.endDateElement?.nativeElement.blur();
        } else {
            this.invalidDateRange = true;
        }
    }
    setDateFormat(selectedDate: string | Date) {
        return selectedDate && selectedDate !== 'Invalid date'
          ? this.datePipe.transform(
              selectedDate,
              this.globalConstants.format.datePipe
            ) || ''
          : '';
    }
    onSelectMeetingType(event: number[]) {
        const index = event.findIndex(id => id === this.constants.selectAllOption.id);
        if (index > -1) {
            // if user selects select all option
            this.selectedAll = true;
            this.selectAllMeetingType(true);
        } else {
            // if user selects specific meetting types
            this.allMeetingTypes.forEach((meetingTypeDetails: MeetingTypeList, index: number) => {
                if (event.indexOf(meetingTypeDetails.id) > -1) {
                    meetingTypeDetails.selected = true;
                } else {
                    meetingTypeDetails.selected = false;
                }
            });
            this.checkIfAllSelected(0, true);
        }
    }

    toggleCalendarVisibility () {
        this.calendarVisibility = !this.calendarVisibility;
    }
}
